/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestMigrationAllPost } from '../fn/migration/api-request-migration-all-post';
import { ApiRequestMigrationAllPost$Params } from '../fn/migration/api-request-migration-all-post';
import { apiRequestMigrationApplicationPost } from '../fn/migration/api-request-migration-application-post';
import { ApiRequestMigrationApplicationPost$Params } from '../fn/migration/api-request-migration-application-post';
import { apiRequestMigrationCorporatePost } from '../fn/migration/api-request-migration-corporate-post';
import { ApiRequestMigrationCorporatePost$Params } from '../fn/migration/api-request-migration-corporate-post';
import { apiRequestMigrationCoursePost } from '../fn/migration/api-request-migration-course-post';
import { ApiRequestMigrationCoursePost$Params } from '../fn/migration/api-request-migration-course-post';
import { apiRequestMigrationSimulateExcelPost } from '../fn/migration/api-request-migration-simulate-excel-post';
import { ApiRequestMigrationSimulateExcelPost$Params } from '../fn/migration/api-request-migration-simulate-excel-post';
import { apiRequestMigrationSimulatePost } from '../fn/migration/api-request-migration-simulate-post';
import { ApiRequestMigrationSimulatePost$Params } from '../fn/migration/api-request-migration-simulate-post';
import { apiRequestMigrationUserPost } from '../fn/migration/api-request-migration-user-post';
import { ApiRequestMigrationUserPost$Params } from '../fn/migration/api-request-migration-user-post';
import { MigrationResult } from '../models/migration-result';
import { MigrationSimulation } from '../models/migration-simulation';

@Injectable({ providedIn: 'root' })
export class MigrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestMigrationCoursePost()` */
  static readonly ApiRequestMigrationCoursePostPath = '/api/Request/Migration/Course';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationCoursePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationCoursePost$Response(params?: ApiRequestMigrationCoursePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
    return apiRequestMigrationCoursePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationCoursePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationCoursePost(params?: ApiRequestMigrationCoursePost$Params, context?: HttpContext): Observable<MigrationResult> {
    return this.apiRequestMigrationCoursePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationResult>): MigrationResult => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationCorporatePost()` */
  static readonly ApiRequestMigrationCorporatePostPath = '/api/Request/Migration/Corporate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationCorporatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationCorporatePost$Response(params?: ApiRequestMigrationCorporatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
    return apiRequestMigrationCorporatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationCorporatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationCorporatePost(params?: ApiRequestMigrationCorporatePost$Params, context?: HttpContext): Observable<MigrationResult> {
    return this.apiRequestMigrationCorporatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationResult>): MigrationResult => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationUserPost()` */
  static readonly ApiRequestMigrationUserPostPath = '/api/Request/Migration/User';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationUserPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationUserPost$Response(params?: ApiRequestMigrationUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
    return apiRequestMigrationUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationUserPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationUserPost(params?: ApiRequestMigrationUserPost$Params, context?: HttpContext): Observable<MigrationResult> {
    return this.apiRequestMigrationUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationResult>): MigrationResult => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationApplicationPost()` */
  static readonly ApiRequestMigrationApplicationPostPath = '/api/Request/Migration/Application';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationApplicationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationApplicationPost$Response(params?: ApiRequestMigrationApplicationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
    return apiRequestMigrationApplicationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationApplicationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationApplicationPost(params?: ApiRequestMigrationApplicationPost$Params, context?: HttpContext): Observable<MigrationResult> {
    return this.apiRequestMigrationApplicationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationResult>): MigrationResult => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationAllPost()` */
  static readonly ApiRequestMigrationAllPostPath = '/api/Request/Migration/All';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationAllPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationAllPost$Response(params?: ApiRequestMigrationAllPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationResult>> {
    return apiRequestMigrationAllPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationAllPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationAllPost(params?: ApiRequestMigrationAllPost$Params, context?: HttpContext): Observable<MigrationResult> {
    return this.apiRequestMigrationAllPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationResult>): MigrationResult => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationSimulatePost()` */
  static readonly ApiRequestMigrationSimulatePostPath = '/api/Request/Migration/Simulate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationSimulatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationSimulatePost$Response(params?: ApiRequestMigrationSimulatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MigrationSimulation>> {
    return apiRequestMigrationSimulatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationSimulatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationSimulatePost(params?: ApiRequestMigrationSimulatePost$Params, context?: HttpContext): Observable<MigrationSimulation> {
    return this.apiRequestMigrationSimulatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MigrationSimulation>): MigrationSimulation => r.body)
    );
  }

  /** Path part for operation `apiRequestMigrationSimulateExcelPost()` */
  static readonly ApiRequestMigrationSimulateExcelPostPath = '/api/Request/Migration/Simulate/Excel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestMigrationSimulateExcelPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationSimulateExcelPost$Response(params?: ApiRequestMigrationSimulateExcelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRequestMigrationSimulateExcelPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestMigrationSimulateExcelPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestMigrationSimulateExcelPost(params?: ApiRequestMigrationSimulateExcelPost$Params, context?: HttpContext): Observable<string> {
    return this.apiRequestMigrationSimulateExcelPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
